import functions from '@mindthegapstudio/stpancras-storybook-app/src/plugins/functions'
import EventBus from '@/eventBus'
import PresentationApi from '@/api/presentation'
import utils from '@/util'
import socket from '@/socket'

const go = (destinationUrl) => {
  window.location.href = destinationUrl
}

const getErrorMessage = (error, defaultError) => {
  if (error.status !== 500 && error.body && error.body.message) {
    return error.body.message
  }

  return defaultError
}

// since this function is used from inside many different components
// need to use events for easier state management
const isCurrentEditor = async (clickedPrez, vueInstance) => {
  EventBus.$emit('modal-view-only:before-perform-check', clickedPrez)
  try {
    const { body } = await PresentationApi.getTakenOverBy(clickedPrez.id)
    const { takenOverBy } = body
    const hasPerm = !takenOverBy
      || (takenOverBy.id && takenOverBy.id === vueInstance.$store.state.currentUser.id)
    EventBus.$emit('modal-view-only:after-perform-check', { hasPerm, clickedPrez, activeEditor: takenOverBy })
    return hasPerm
  } catch (e) {
    utils.showToastError("Oops, there's an error while performing the action. Please try again.")
    return false
  }
}

// since this function is used from inside many different components
// need to use events for easier state management
const isCurrentEditorRealtime = async (clickedPrez, vueInstance) => {
  EventBus.$emit('modal-view-only:before-perform-check', clickedPrez)

  function _fetch(presentationId) {
    return new Promise((resolve) => {
      socket.emit('get_taken_over_by', presentationId, (response) => {
        resolve(response)
      })
    })
  }

  try {
    const { takenOverBy } = await _fetch(clickedPrez.id)
    const hasPerm = !takenOverBy
      || (takenOverBy.id && takenOverBy.id === vueInstance.$store.state.currentUser.id)
    EventBus.$emit('modal-view-only:after-perform-check', { hasPerm, clickedPrez, activeEditor: takenOverBy })
    return hasPerm
  } catch (e) {
    utils.showToastError("Oops, there's an error while performing the action. Please try again.")
    return false
  }
}

const install = (Vue) => {
  Vue.prototype.$func = {
    ...functions,
    getErrorMessage,
    go,
    isCurrentEditor,
    isCurrentEditorRealtime,
  }
}

export default {
  install,
}
